import React, { useEffect } from 'react';
import { useWorkspaceMap } from './hooks/WorkspaceMap.hook';
import { useSelector } from 'react-redux';
import { isMexico } from '@/helpers/locationHelpers';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import WorkspaceMapView from './views/WorkspaceMapView';
import HomeView from './views/HomeView';
import LoadingComponent from '@/components/general/Loading/LoadingComponent';

const WorkspaceMapController = () => {
  const currencyData = useSelector((state) => state.currency);
  const location = useSelector((state) => state.location?.data);
  const lenguage = useSelector((state) => state.lenguage?.lang);
  const isFromMexico = isMexico(location);
  const { isLoading, workspacesDataFromBackend } = useWorkspaceMap(currencyData, isFromMexico);
  if (isLoading) {
    return <LoadingComponent loading={isLoading} />;
  } else {
    return (
      <>
        <FlexContainer className={'flex-column width100 d-hide'}>
          <WorkspaceMapView workspacesDataFromBackend={workspacesDataFromBackend} />
        </FlexContainer>
        <FlexContainer className={'flex-column width100 m-hide'}>
          <HomeView
            spacesDataFromBackend={workspacesDataFromBackend}
            //blogsDataFromBackend={blogsDataFromBackend}
            lenguage={lenguage}
            currencyData={currencyData}
          />
        </FlexContainer>
      </>
    );
  }
};

export default WorkspaceMapController;
